import React, { useEffect, useState } from 'react';
import {
  Box,
  InfoIcon,
  InputAdornment,
  IPagePanelFooter,
  TextField,
  Tooltip
} from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useSelector } from 'react-redux';

import { getApplicationLocale } from '@epi-store/application/application.selectors';
import { showNotification } from '@epi-actions/overlays';
import {
  useUpdateEndOfFundsPeriodMutation,
  useGetMetadataQuery
} from '@epi-api/companyMetadata/companyMetadataApi';

export const BeneficiariesSettings = ({
  setFooter
}: {
  setFooter: (footer: IPagePanelFooter) => void;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const language = useSelector(getApplicationLocale);
  const [updateEndOfFundsPeriod] = useUpdateEndOfFundsPeriodMutation();
  const { data: companyMetadata } = useGetMetadataQuery();
  const [value, setValue] = useState<string>(
    companyMetadata?.endOfFundsPeriod?.toString() || ''
  );

  const handleSaveSettings = () => {
    try {
      updateEndOfFundsPeriod(Number(value));
      showNotification({ message: 'messages.company_info_updated' }, 'success');
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setFooter({
      submitText: t('containers.beneficiaries.tabs.settings.save'),
      onSubmit: handleSaveSettings,
      disableSubmit:
        value === undefined ||
        value === '' ||
        value === companyMetadata?.endOfFundsPeriod?.toString()
    });
  }, [value, language]);

  const onChange = event => {
    const sanitizedValue = (event.target.value || '').replace(/[^\d]/g, '');
    setValue(sanitizedValue);
  };

  return (
    <Box width={450} pt={3} pb={2}>
      <TextField
        label={t('containers.beneficiaries.tabs.settings.label')}
        value={value}
        id="beneficiaries-settings-amount"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Box
                fontSize={theme.sizeMedium}
                display="flex"
                alignItems="center"
                gap={1}
              >
                {t('containers.beneficiaries.tabs.settings.units')}
                <Tooltip
                  arrow
                  placement="top"
                  id={`credit-card-tooltip`}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: '500px'
                      }
                    }
                  }}
                  title={
                    <Trans
                      i18nKey={t(
                        'containers.beneficiaries.tabs.settings.tooltip'
                      )}
                    />
                  }
                >
                  <Box id={`credit-card}-info-icon`}>
                    <InfoIcon color={theme.gray50} />
                  </Box>
                </Tooltip>
              </Box>
            </InputAdornment>
          )
        }}
        onChange={onChange}
      />
    </Box>
  );
};
